import { render } from "./UpdatesAsync.vue?vue&type=template&id=d40a896c&scoped=true"
import script from "./UpdatesAsync.vue?vue&type=script&lang=js"
export * from "./UpdatesAsync.vue?vue&type=script&lang=js"

import "./UpdatesAsync.vue?vue&type=style&index=0&id=d40a896c&lang=postcss&scoped=true"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d40a896c"]])

export default __exports__